export default Object.freeze({
  READ: 'read',
  REQUEST: 'request',
  SHOP: 'shop',
  OPEN_IN_BIBIS: 'openInBibis'
})
